import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ConfigService } from '../../../../core';
import {
  amostra,
  bonificacao,
  ConfigPedidoTipoVendaIndicador,
  consignacao,
  getTipoVendaIndicador,
  orcamento,
  remessa,
  simulacao,
  tipoVendaOutro,
  venda
} from '../../../../home/configuracoes/app/pedido/tipo-venda/config-pedido-tipo-venda-indicador';
import { ConfigPedidoTipoVendaPipe } from '../../../../home/configuracoes/app/pedido/tipo-venda/pipes';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-config-pedido-tipo-venda-multi-select',
  templateUrl: './novo-config-pedido-tipo-venda-multi-select.component.html',
  styleUrls: ['./novo-config-pedido-tipo-venda-multi-select.component.scss'],
  providers: [
    ConfigPedidoTipoVendaPipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(
        () => NovoConfigPedidoTipoVendaMultiSelectComponent
      ),
      multi: true
    }
  ]
})
export class NovoConfigPedidoTipoVendaMultiSelectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() tiposVendas: number[];
  @Input() variante: 'filtro' | undefined;
  @Input() icon = 'fa-hand-holding-usd';

  @Output() tiposVendasChange = new EventEmitter<number[]>();

  options: IOption[] = [];
  settings: IMultiSelectSettings = {
    placeholder: 'Tipos de Venda',
    singular: 'Tipo de Venda',
    plural: 'Tipos de Venda',
    searchEmptyResultMessage: 'Nenhum tipo de venda encontrado',
    showFooter: true
  };

  constructor(
    private configService: ConfigService,
    private configPedidoTipoVendaPipe: ConfigPedidoTipoVendaPipe
  ) {
    super();
  }

  ngOnInit() {
    this.create();
  }

  private create() {
    this.options = (this.configService.getPedido()?.tiposVenda ?? []).map(
      (tipo) => ({
        id: tipo.tipoVenda,
        label: this.configPedidoTipoVendaPipe.transform(tipo.tipoVenda),
        isChecked: false,
        cssClass: this.getCssClass(getTipoVendaIndicador(tipo.tipoVenda))
      })
    );
  }

  private getCssClass(tipo: ConfigPedidoTipoVendaIndicador): string {
    switch (tipo) {
      case venda:
        return 'tipo-venda__venda';
      case bonificacao:
        return 'tipo-venda__bonificacao';
      case amostra:
        return 'tipo-venda__amostra';
      case consignacao:
        return 'tipo-venda__consignacao';
      case remessa:
        return 'tipo-venda__remessa';
      case simulacao:
        return 'tipo-venda__simulacao';
      case orcamento:
        return 'tipo-venda__orcamento';
      case tipoVendaOutro:
        return 'tipo-venda__outro';
      default:
        return '';
    }
  }

  protected updateValue(newValue: number[] | null): void {
    this.tiposVendas = newValue || [];
  }

  onSelectionChange(): void {
    this.emitChange(this.tiposVendas);
  }

  onSearch(): void {
    this.tiposVendasChange.emit(this.tiposVendas);
  }
}
